import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/index.scss'
import SvgIcon from '@/icons'
import 'element-plus/dist/index.css'
import '@/assets/scss/style.scss'
import '@/router/permission'
import * as ELIcons from '@element-plus/icons-vue'
// import dataV from '@jiaminghi/data-view'
import i18n from '@/i18n'
import moment from 'moment'
// import VueEnhance from '@/plugins/VueEnhance'
import VueQrcode from '@chenfengyuan/vue-qrcode'
// 引入VForm 3库
// import VForm3 from 'vform3-builds'
// 引入VForm3样式
// 引入element-plus库(为了用表单设计：原先使用局部引入)
// import ElementPlus from 'element-plus' // 全局引入
// 引入暗黑模式
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/dark/css-vars.css'
import objCopy from './utils/objCopy'
import myconfirm from './utils/myconfirm'
const app = createApp(App)
app.config.globalProperties.$objCopy = objCopy
app.config.globalProperties.$myconfirm = myconfirm
// 将i18n 实例添加到 app 上，以便全局访问
app.config.globalProperties.$i18n = i18n
const param: any = ELIcons
for (const iconName in ELIcons) {
    app.component(iconName, param[iconName])
}
// app.component(VueQrcode.name, VueQrcode)
app.config.globalProperties.$moment = moment
app.config.warnHandler = () => null
SvgIcon(app)
app.use(store)
    // .use(ElementPlus) // 全局注册element-plus
    .use(router)
    .use(i18n)
    // .use(dataV)
    // .use(VForm3) // 全局注册VForm 3(同时注册了v-form-designer和v-form-render组件)
    // .use(VueEnhance)
    .mount('#app')
// console.log('Element Plus Version:', ElementPlus.version)
